import React from 'react';

import { GetExecutionResponse } from '@blockworks/platform/api/research/studio/execution';
import { ObjUnion } from '@blockworks/platform/typescript';

import type { GridItemSettingsProps } from '../../../dashboard-grid/grid-item/grid-item-content/grid-item-settings';
import type { MergedVisualizationExecutionData } from '../../models';

type VisualizationRendererProps = {
    visualization: Pick<
        MergedVisualizationExecutionData,
        'config' | 'title' | 'queryId' | 'type' | 'description' | 'id' | 'subTitle' | 'slug'
    > & { execution: GetExecutionResponse['data'] };
    editing?: boolean;
    disableExpand?: boolean;
    disableSharing?: boolean;
    disableExport?: boolean;
    layoutSettings?: {
        defaultControl?: 'toggle' | 'dropdown';
        controlSize?: 'xxs' | 'xs';
        headerHeight?: number;
    };
    componentSlots?: {
        Header?: React.FC<ObjUnion<{ queryId: string; title: string; visualizationId: string }>>;
        HeaderEnd?: React.FC<ObjUnion<GridItemSettingsProps>>;
        HeaderTitle?: React.FC<ObjUnion<{ queryId: string; title: string; visualizationId: string }>>;
    };
};

const FEATURE_CONTROL_BUTTONS_BAR_ID = 'visualization-feature-controls';
const VISUALIZATION_INNER_WRAPPER_HTML_ID = 'visualization-inner-wrapper';
const VISUALIZATION_WORDMARK_HTML_ID = 'visualization-wordmark';

export type { VisualizationRendererProps };
export { FEATURE_CONTROL_BUTTONS_BAR_ID, VISUALIZATION_INNER_WRAPPER_HTML_ID, VISUALIZATION_WORDMARK_HTML_ID };
